// extracted by mini-css-extract-plugin
export default {"cls1":"VeloRadioTileGroup-ImageTileText_cls1__dkAcg","cls2":"VeloRadioTileGroup-ImageTileText_cls2__gM8YO VeloRadioTileGroup-ImageTileText_cls1__dkAcg"};